import React, { useEffect, useState } from "react";
import Papa from 'papaparse';
// ysjeon | react-wordcloud 의존성 문제로 임시 주석 처리
// import WordCloud from "react-wordcloud";
import { Button } from "../components";
import { useStateContext } from "../contexts/ContextProvider";
import { KeywordsWordCloud_cloud } from "../data/dummy";
import { useNavigate, useLocation } from "react-router-dom";

const Wordcloud = ({ sentiment, pageType, keywordColors, intentName }) => {
  const { currentColor } = useStateContext();
  const navigate = useNavigate();

  // 워드클라우드 옵션 설정
  const options = {
    rotations: 2,
    rotationAngles: [0, 0],
    fontSizes: [15, 50],
    deterministic: true, // 단어의 위치를 고정
  };

  // 단어에 따라 색상 지정
  // ysjeon | react-wordcloud 의존성 문제로 임시 주석 처리
  // const callbacks = {
  //   getWordColor: (word) => {
  //     return keywordColors[word.text] || null; // null 반환 시 react-wordcloud의 기본 색상 사용
  //   },
  // };

  const handleButtonClick = () => {
    // Button 클릭 시 navigate로 intentName과 sentiment를 전달
    navigate("/vis/wordcloud-edit", {
      state: { intentName, sentiment }, // state로 전달
    });
  };

  return (
    <div style={{ height: "500px" }}>
      {pageType === "전체" && (
        <div className="flex gap-5">
          <p className="text-s">{sentiment} 리뷰</p>
          {/* <Button
            color="white"
            bgColor={currentColor}
            text="차트 편집하기"
            borderRadius="10px"
            onClick={handleButtonClick} // 클릭 시 전달
          /> */}
        </div>
      )}
      {/* ysjeon | react-wordcloud 의존성 문제로 임시 주석 처리 */}
      {/* <WordCloud words={KeywordsWordCloud} options={options} callbacks={callbacks} /> */}
      {/* <WordCloud words={KeywordsWordCloud_cloud[intentName][sentiment]} options={options} callbacks={callbacks} /> */}
      
      {/* 임시 대체 컴포넌트 */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '100%',
        backgroundColor: '#f5f5f5',
        borderRadius: '8px',
        border: '2px dashed #ccc'
      }}>
        <p style={{ color: '#666', fontSize: '16px' }}>
          워드클라우드 컴포넌트 (react-wordcloud 의존성 문제로 임시 비활성화)
        </p>
      </div>
    </div>
  );
};

export default Wordcloud;
